import React from "react";
import { Button } from "./ui/button";
import { MapPin, Car, Star, X } from "lucide-react";
import { naira, StateBadge } from "./appHelpers";

const CANCELLABLE = ["REQUESTED", "BIDDING", "DRIVER_SELECTED", "BID_ACCEPTED", "DRIVER_EN_ROUTE"];

function BidList({ ride, onAccept }) {
  return (
    <div className="mt-4">
      <div className="text-sm font-semibold text-white mb-2">Driver bids ({ride.bids.length})</div>
      {ride.bids.length === 0 && <p className="text-white/40 text-sm">Waiting for drivers to bid…</p>}
      <div className="space-y-2">
        {ride.bids.map((b) => (
          <div key={b.id} className="flex items-center justify-between rounded-xl bg-[#0a0e0c] border border-white/10 px-3 py-2">
            <div className="flex items-center gap-2 text-sm text-white/80"><Car className="h-4 w-4 text-[#2fd645]" /> {b.driver_name}</div>
            <div className="flex items-center gap-3">
              <span className="font-bold text-[#2fd645]">{naira(b.amount)}</span>
              <Button data-testid={`accept-bid-${b.id}`} onClick={() => onAccept(ride.id, b.id)} className="h-8 px-3 bg-[#2fd645] text-[#06210b] font-bold rounded-lg text-xs">Accept</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function PassengerRideCard({ ride: r, onAccept, onCancel }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-[#0e1311] p-5">
      <div className="flex items-center justify-between">
        <StateBadge state={r.state} />
        <span className="text-sm text-white/50">{r.category}</span>
      </div>
      <div className="mt-3 flex items-center gap-2 text-sm text-white/80">
        <MapPin className="h-4 w-4 text-[#2fd645]" /> {r.pickup} <span className="text-white/40">→</span> {r.destination}
      </div>
      <div className="mt-1 text-xs text-white/50">{r.distance_km} km · ~{r.duration_min} min · your offer {naira(r.proposed_fare)}</div>
      {r.state === "BIDDING" && <BidList ride={r} onAccept={onAccept} />}
      {r.driver_name && r.state !== "BIDDING" && (
        <div className="mt-4 flex items-center justify-between rounded-xl bg-[#0a0e0c] border border-white/10 px-3 py-2">
          <div className="flex items-center gap-2 text-sm text-white/80"><Star className="h-4 w-4 text-[#2fd645]" fill="#2fd645" /> {r.driver_name}</div>
          <span className="font-bold text-[#2fd645]">{naira(r.final_fare || r.proposed_fare)}</span>
        </div>
      )}
      {CANCELLABLE.includes(r.state) && (
        <button data-testid={`cancel-ride-${r.id}`} onClick={() => onCancel(r.id)} className="mt-3 inline-flex items-center gap-1 text-xs text-white/50 hover:text-red-400">
          <X className="h-3 w-3" /> Cancel ride
        </button>
      )}
    </div>
  );
}
